import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ServiceNames } from '../../interfaces/my7n-env-config';
import { delay, Observable, of, switchMap } from 'rxjs';
import { ICvParseIdResponse } from '../../interfaces/cv';
import { AppConfigService } from '../app-config.service';
import { IActiveParsingResponse } from '../../interfaces/cv-parse';

@Injectable()
export class CvParseService {
  readonly CV_V1_API: string;
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.CV_V1_API = appConfigService.serviceUrl(ServiceNames.Cv, 'v1') + 'cv/';
  }
  /**
   * Get active parsing for current user
   */
  getUserActiveParsing(): Observable<IActiveParsingResponse> {
    return this.http.get<IActiveParsingResponse>(`${this.CV_V1_API}parser/active-parsing`);
  }

  /**
   * Cancel active parsing for specific CV
   * @param cvId
   */

  cancelParsing(cvId: number): Observable<void> {
    return this.http.post<void>(`${this.CV_V1_API}parser/cancel/${cvId}`, {});
  }

  /**
   * Parse given cv file and create new CV based on detected data.
   * CV will be created for specific user
   * @param userId
   * @param cvFile
   */
  uploadFileToParse(cvFile: File): Observable<IActiveParsingResponse> {
    const formData: FormData = new FormData();
    formData.append('cvFile', cvFile);
    return this.http.post<IActiveParsingResponse>(`${this.CV_V1_API}parser/parse-async`, formData);
  }

  /**
   * Parse given cv file and create new CV based on detected data.
   * CV will be created for specific user
   * @param userId
   * @param cvFile
   */
  uploadFileToParseByAgent(userId: string, cvFile: File): Observable<IActiveParsingResponse> {
    const formData: FormData = new FormData();
    formData.append('cvFile', cvFile);
    return this.http.post<IActiveParsingResponse>(`${this.CV_V1_API}parser/parse-async/${userId}`, formData);
  }

  /**
   * Get parsing result for specific cvId
   * @param cvId
   */

  getParsingResultByCvId(cvId: number): Observable<HttpResponse<void>> {
    return this.http.get<void>(`${this.CV_V1_API}parser/result/${cvId}`, { observe: 'response' });
  }
}
